import { render, staticRenderFns } from "./survey-step-apolipoprotein-b-test.vue?vue&type=template&id=ec09beec"
import script from "./survey-step-apolipoprotein-b-test.vue?vue&type=script&lang=js"
export * from "./survey-step-apolipoprotein-b-test.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports